import type { EditorSelectFieldsProps } from "./schema-builder-field-editor-select.type";

import { SchemaBuilderSelect } from "../../schema-builder-select";
import { EditorDefaultFields } from "../schema-builder-field-editor-default";

export const EditorSelectFields = ({
  initialValues,
}: EditorSelectFieldsProps) => {
  return (
    <>
      <EditorDefaultFields />
      <SchemaBuilderSelect
        name="values"
        initialValues={initialValues["values"]}
      />
    </>
  );
};
